// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"26062424","359":"8a8a6d43","529":"4cb407a4"}[chunkId] + ".chunk.js";
};